import { render } from "./ModalUploadProdutos.vue?vue&type=template&id=34738112&ts=true"
import script from "./ModalUploadProdutos.vue?vue&type=script&lang=ts"
export * from "./ModalUploadProdutos.vue?vue&type=script&lang=ts"

import "./ModalUploadProdutos.vue?vue&type=style&index=0&id=34738112&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__